import cx from "classnames";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import "./OptionsToggle.css";

const OptionsToggle = (props) => {
    const {
        label, options,
        value, onChange,
        vertical, className,
        additionalBlock,
        disabled,
    } = props;

    return (
        <div className={cx("options-toggle", { "options-toggle--vertical": vertical }, className)}>
            {label && <span className="options-toggle__label">{label}</span>}
            <ToggleButtonGroup
                value={value}
                exclusive
                onChange={(_, v) => v !== null && v !== undefined && onChange(v)}
                className="options-toggle__toggle"
                disabled={disabled}
            >
                {(options || []).map((option) => (
                    <ToggleButton
                        key={option.value}
                        value={option.value}
                        aria-label={option.title}
                        className="options-toggle__button"
                    >
                        <span className="options-toggle__icon">
                            {value === option.value && <DoneIcon />}
                        </span>
                        <Typography variant="h3" component="div" className="options-toggle__button-title">
                            {option.title}
                        </Typography>
                        {option.content && (
                            <Typography variant="body1" component="div" className="options-toggle__button-description">
                                {option.content}
                            </Typography>
                        )}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            {additionalBlock}
        </div>
    );
};

export default OptionsToggle;
